import { Panel } from "primereact/panel";
import { Ripple } from "primereact/ripple";

const REIToggablePanel = ({
  id,
  footerTemplate,
  customClassName,
  header,
  istoggleable,
  contentComponent,
  defaultCollapse = true,
  customHeader = null,
}: {
  id?: string;
  footerTemplate?: JSX.Element;
  customClassName?: string;
  header: string;
  istoggleable: boolean;
  contentComponent: JSX.Element;
  defaultCollapse: boolean;
  customHeader?: any | null;
}) => {
  const template = (options: any) => {
    const toggleIcon = options.collapsed ? "pi pi-chevron-right text-white" : "pi pi-chevron-down text-white";
    const className = `${options.className} justify-content-start panel-header ${!istoggleable ? "min-h-[48px]" : ""}`;
    const buttonClassName = `${options.togglerClassName} mr-2 hover:bg-slate-500`;
    return (
      <div className={`${className} bg-slate-600 text-white`}>
        <span className="font-bold">{header}</span>
        {istoggleable && (
          <button id={id} data-testid={id} className={buttonClassName} onClick={options.onTogglerClick}>
            <span className={toggleIcon}></span>
            <Ripple />
          </button>
        )}
      </div>
    );
  };

  return (
    <Panel
      className={`${"rei-toggable-panel"} ${customClassName}`}
      footerTemplate={footerTemplate}
      headerTemplate={customHeader ? customHeader : template}
      toggleable={istoggleable}
      collapsed={defaultCollapse}
    >
      {contentComponent}
    </Panel>
  );
};

export default REIToggablePanel;
